import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import { useTranslation } from "react-i18next";

import MoreInformationModal from "./MoreInformationModal";

import "swiper/swiper-bundle.min.css";

import classes from "./Carousel.module.css";

const Carousel = ({ data }) => {
  const { t } = useTranslation();

  const [openModal, setOpenModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedChar, setSelectedChar] = useState(null);

  const teamSlider = {
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    loop: true,
    spaceBetween: 20,
    navigation: true,
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      576: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 4,
      },
    },
  };

  const onClickMore = (selectedId) => {
    const newArr = data.filter((value) => value.id === selectedId);
    setSelectedChar(newArr);
    setSelectedId(selectedId);
    setOpenModal(true);
  };

  const onClose = () => {
    setOpenModal(false);
  };

  if (openModal) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }

  return (
    <div className={classes["carousel-wrapper"]}>
      <Swiper {...teamSlider} modules={[Navigation, Pagination]}>
        {data.map((value) => {
          return (
            <SwiperSlide key={value.id} className={classes["carousel"]}>
              <img className={classes["value-img"]} src={value.img} alt="" />
              <h3 className={classes["value-fullName"]}>
                {value.name} {value.lastName}{" "}
              </h3>
              <p className={classes["value-workplace"]}>{value.workplace}</p>
              <div
                onClick={() => onClickMore(value.id)}
                className={classes["more-button"]}
              >
                {t("More")}
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
      {openModal ? (
        <MoreInformationModal onClose={onClose} selectedData={selectedChar} />
      ) : null}
    </div>
  );
};

export default Carousel;
